import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLockMdc = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 24.453c1.705 0 3.011-1.378 3.011-3.083S17.705 18.358 16 18.358s-3.011 1.306-3.011 3.012 1.306 3.083 3.011 3.083zm7.655-16.798v3.084h1.488c1.705 0 3.084 1.27 3.084 2.975v15.31c0 1.706-1.379 2.976-3.084 2.976H6.857c-1.705 0-3.084-1.27-3.084-2.975v-15.31c0-1.706 1.379-2.976 3.084-2.976h1.488V7.655C8.345 3.375 11.719 0 16 0s7.655 3.374 7.655 7.655zM16 3.084c-2.576 0-4.571 1.995-4.571 4.571v3.084h9.142V7.655c0-2.576-1.995-4.571-4.571-4.571z" /></svg>;
export default SvgLockMdc;